module.exports = __webpack_public_path__ + "img/cayman_islands.920027d.webp";